/**
 * Created by luka on 23.02.2018.
 */
import {post} from "../utils/api";
import {DECLINE_SUCCESSFUL, PAYOUT_REQUEST_SUCCESSFUL} from "../utils/constants";
import {
    DECLINE_PAYOUT_LOADING, DECLINE_PAYOUT_SUCCESS, LOADING_DECLINE_PAYOUT_FAILED, LOADING_REQUEST_PAYOUT_FAILED,
    REQUEST_PAYOUT_LOADING, REQUEST_PAYOUT_SUCCESS,
} from "../actions/types";
import {daysFetchData} from "../overview/OverviewAction";
import {navigationToPayoutSuccess, navigationToMilestone} from "../navigation/NavigationActions";
import {milestoneTypes} from "../milestone/MilestoneScreen";

export function loadingRequestPayoutFailed(error) {
    return {
        type: LOADING_REQUEST_PAYOUT_FAILED,
        error
    };
}

export function requestPayoutLoading(bool) {
    return {
        type: REQUEST_PAYOUT_LOADING,
        isLoading: bool
    };
}

export function requestPayoutSuccess(response) {
    return {
        type: REQUEST_PAYOUT_SUCCESS,
        response
    };
}

export function fetchRequestPayout(bankAccount) {
    return (dispatch) => {
        dispatch(requestPayoutLoading(true));

        post('requestPayout', {
            bankAccount: bankAccount
        })
            .then((response) => {
                if (response.msg === PAYOUT_REQUEST_SUCCESSFUL) {
                    dispatch(requestPayoutSuccess(response));
                    dispatch(navigationToMilestone({type: milestoneTypes.payout}));
                }else{
                    dispatch(requestPayoutSuccess(response));
                }
                dispatch(requestPayoutLoading(false));
            })
            .catch((error) => {
                dispatch(loadingRequestPayoutFailed(error));
                dispatch(requestPayoutLoading(false));
            });
    };
}


// WEBPACK FOOTER //
// ./src/payout/RequestPayoutAction.js